import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("ekoYS"), parcelRequire.load("6qO4J"), parcelRequire.load("8nwb6")]).then(() => {
  return Promise.all([waitForCSS("/Accordion.8def871b.css")]);
}).then(() => {
let originalModule = parcelRequire("lVVdJ");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("ekoYS")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6qO4J")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("8nwb6")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
